import { type AvailableCriterionGroup } from '@hooks-api/types/dataModel/coupon'

/**
 * 由於 criterion_groups 有可能具有 A + B 的組合，透過統一的邏輯取得應該要呈現在介面上的資訊
 */
export const getCouponDisplayInfo = (criterionGroups: AvailableCriterionGroup[],
) => {
  const criterionGroup = criterionGroups.find(group => group.criterions.length > 0)
  if (!criterionGroup) return null
  const firstCriterion = criterionGroup.criterions[0]
  if (!firstCriterion) return null
  const maxDiscountAmountCriterion = criterionGroup.criterions.reduce((max, criterion) => {
    if (criterion.discount_amount && max?.discount_amount && criterion.discount_amount > max.discount_amount) return criterion
    if (criterion.discount_rate && max?.discount_rate && criterion.discount_rate > max.discount_rate) return criterion
    return max
  }, criterionGroup.criterions[0])
  return {
    criterionGroup,
    firstCriterion,
    maxDiscountAmountCriterion,
    criterions: criterionGroup.criterions,
  }
}
